var trimProtocolFromUrl = function (url) { return url.replace(/https?:\/\//, ""); };
export default trimProtocolFromUrl;
